// extracted by mini-css-extract-plugin
export default {"adder":"AddAccount_adder__oV8dd","plus":"AddAccount_plus__2qH02","dialog":"AddAccount_dialog__11hE6","form":"AddAccount_form__wgnJ-","generate":"AddAccount_generate__r5KxF"};